import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IAuthData } from '../../initialState';

interface IForgotPasswordSuccessAction {
  email: string;
}

function forgotPasswordSuccess(
  draft: Draft<IAuthData>,
  action: PayloadAction<IForgotPasswordSuccessAction>,
) {
  draft.forgotPassword.config.isLoading = false;
  draft.forgotPassword.config.email = action.payload.email;
}

export default forgotPasswordSuccess;
